import styled from '@emotion/styled';
import { FileCopy } from '@mui/icons-material';

// eslint-disable-next-line import/prefer-default-export
export const CopyIcon = styled(FileCopy)`
  margin-left: 5px;
  font-size: 15px;
`;
